import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  private tokenKey = 'app_token';

  constructor(private cookieService: CookieService) { }

  saveToken(token: string): void {
    this.cookieService.set(this.tokenKey, token, {
      secure: true,
      sameSite: 'Strict',
      path: '/',
      expires: 7
    });
  }

  getToken(): string | null {
    return this.cookieService.get(this.tokenKey) || null;
  }

  clearToken(): void {
    this.cookieService.delete(this.tokenKey, '/');
  }
}
